import { render, staticRenderFns } from "./YourStakeLogo.vue?vue&type=template&id=b3bd5940&"
import script from "./YourStakeLogo.vue?vue&type=script&lang=js&"
export * from "./YourStakeLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports